<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
                <b-col lg="12" sm="12">
                    <b-row>
                        <b-col lg="12" sm="12">
                            <b-row>
                                <b-col md=12>
                                    <b-table-simple striped bordered small hover>
                                        <tbody>
                                            <b-tr>
                                                <b-td width="30%">{{ $t('globalTrans.organization') }}</b-td>
                                                <b-td colspan="3">{{ (currentLocale === 'en') ? course.org_name : course.org_name_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('child_configuration.institute_type') }}</b-td>
                                                <b-td colspan="3">{{ (currentLocale === 'en') ? course.office_type : course.office_type_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('child_configuration.institute_name') }}</b-td>
                                                <b-td colspan="3">{{ (currentLocale === 'en') ? course.office_name : course.office_name_bn }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('ds_institute_management.budget_for') }}</b-td>
                                                <b-td colspan="3">{{ $i18n.locale === 'bn' ? course.budget_for_bn : course.budget_for }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('ds_institute_management.budget_amount') }}</b-td>
                                                <b-td colspan="3">{{ $n(course.budget_amount) }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('globalTrans.remarks') }}</b-td>
                                                <b-td colspan="3">{{ (currentLocale === 'en') ? course.remarks : course.remarks_bn }}</b-td>
                                            </b-tr>
                                        </tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'

export default {
  props: ['id', 'url'],
  components: {
  },
  data () {
    return {
      course: {
      }
    }
  },
  created () {
    if (this.id) {
        const tmp = this.getCoureData()
        this.course = tmp
    }
  },
  mounted () {
    core.index()
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
  },
  methods: {
    getOrgName (orgId) {
        const tmpData = this.$store.state.commonObj.organizationProfileList.find(item => item.value === orgId && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getInstituteType (Id) {
        const tmpData = this.$store.state.commonObj.officeTypeList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getCoureData () {
        const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
        return JSON.parse(JSON.stringify(tmpData))
    }
  }
}
</script>
